// Export CSV da tabela "Localidades monitoradas" (Visão Geral Agro).
// Dialeto Excel pt-BR: separador ';', decimal com vírgula, BOM UTF-8.
// Nulls viram célula vazia (não "—") para o Excel manter as colunas numéricas.
// Contrato: ADENDO-2 de docs/contracts/agro-overview.md (BE).
import { AgroOverviewLocation } from 'types/Meteorology/Agro/Overview/Dashboard';
import { downloadBlob } from 'helper/downloadFile';
import { LOCATION_COLUMNS, RISK_LABEL, removerSufixoUf } from './locationsTable';

const DELIMITER = ';';
const BOM = '\ufeff';
// Cabecalho igual ao da tela (fonte unica LOCATION_COLUMNS, sem unidades).
const HEADER = ['Localidade', 'UF', ...LOCATION_COLUMNS.map((c) => c.label)];

function escapeCsvField(field: string): string {
  if (field.includes(DELIMITER) || field.includes('"') || field.includes('\n')) {
    return `"${field.replace(/"/g, '""')}"`;
  }
  return field;
}

function ptBrNumber(value: number | null): string {
  return value === null ? '' : String(value).replace('.', ',');
}

export function buildLocationsCsv(rows: AgroOverviewLocation[]): string {
  const lines = rows.map((loc) => [
    removerSufixoUf(loc.nome, loc.estado),
    loc.estado ?? '',
    loc.diasSemChuva === null ? '' : String(loc.diasSemChuva),
    ptBrNumber(loc.armPct),
    ptBrNumber(loc.chuva7dMm),
    loc.risco7d === null ? '' : RISK_LABEL[loc.risco7d],
    // Mesma precisão da célula PERDA 7D da tela (toFixed(1)).
    loc.perdaAgua7dMm === null ? '' : loc.perdaAgua7dMm.toFixed(1).replace('.', ','),
  ].map(escapeCsvField).join(DELIMITER));
  return [HEADER.join(DELIMITER), ...lines].join('\n');
}

export function buildLocationsCsvFile(rows: AgroOverviewLocation[]): string {
  return BOM + buildLocationsCsv(rows);
}

export function exportLocationsCsv(rows: AgroOverviewLocation[], now: Date = new Date()): void {
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const filename = `visao-geral-agro_${now.getFullYear()}-${mm}-${dd}.csv`;
  const blob = new Blob([buildLocationsCsvFile(rows)], { type: 'text/csv;charset=utf-8' });
  downloadBlob(blob, filename);
}
